import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import apiClient from '../../utils/api';
import './BankTransferPage.css';

function BankTransferPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { order, amount, orderNumber } = location.state || {};
  const [bankDetails, setBankDetails] = useState({
    recipient: 'Sanigenesis LLC',
    iban: 'BE60905200941870',
    bic: 'TRWIBEB1XXX',
    bank: 'WISE'
  });

  useEffect(() => {
    // Fetch bank details from admin settings
    fetchBankDetails();
  }, []);

  const fetchBankDetails = async () => {
    try {
      const settings = await apiClient.getPublicPaymentSettings();
      if (settings.bank_transfer_enabled) {
        setBankDetails({
          recipient: settings.bank_account_holder || 'Sanigenesis LLC',
          iban: settings.bank_account_iban || 'BE60905200941870',
          bic: settings.bank_account_bic || 'TRWIBEB1XXX',
          bank: settings.bank_name || 'WISE'
        });
      }
    } catch (error) {
      console.error('Error fetching bank details:', error);
    }
  };

  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text);
    alert(`${label} wurde in die Zwischenablage kopiert!`);
  };

  return (
    <div className="bank-transfer-page" data-testid="bank-transfer-page">
      <div className="bank-transfer-container">
        <div className="bank-transfer-icon">🏦</div>
        <h1 className="bank-transfer-title">Banküberweisung</h1>
        <p className="bank-transfer-subtitle">
          Bitte überweise den Betrag auf folgendes Konto:
        </p>

        <div className="bank-details-card">
          <div className="detail-row">
            <span className="detail-label">Empfänger:</span>
            <span className="detail-value">{bankDetails.recipient}</span>
            <button 
              onClick={() => copyToClipboard(bankDetails.recipient, 'Empfänger')}
              className="btn-copy"
              data-testid="copy-recipient"
            >
              📋
            </button>
          </div>

          <div className="detail-row">
            <span className="detail-label">IBAN:</span>
            <span className="detail-value monospace">{bankDetails.iban}</span>
            <button 
              onClick={() => copyToClipboard(bankDetails.iban, 'IBAN')}
              className="btn-copy"
              data-testid="copy-iban"
            >
              📋
            </button>
          </div>

          <div className="detail-row">
            <span className="detail-label">BIC:</span>
            <span className="detail-value monospace">{bankDetails.bic}</span>
            <button 
              onClick={() => copyToClipboard(bankDetails.bic, 'BIC')}
              className="btn-copy"
              data-testid="copy-bic"
            >
              📋
            </button>
          </div>

          <div className="detail-row">
            <span className="detail-label">Bank:</span>
            <span className="detail-value">{bankDetails.bank}</span>
          </div>

          <div className="detail-row highlight">
            <span className="detail-label">Betrag:</span>
            <span className="detail-value large">{amount}€</span>
          </div>

          <div className="detail-row highlight">
            <span className="detail-label">Verwendungszweck:</span>
            <span className="detail-value monospace">{orderNumber}</span>
            <button 
              onClick={() => copyToClipboard(orderNumber, 'Verwendungszweck')}
              className="btn-copy"
              data-testid="copy-reference"
            >
              📋
            </button>
          </div>
        </div>

        <div className="important-note">
          <div className="note-icon">⚠️</div>
          <div className="note-content">
            <h3>Wichtig!</h3>
            <p>
              Bitte gib unbedingt den <strong>Verwendungszweck</strong> an, damit wir deine Zahlung zuordnen können.
            </p>
            <p>
              Nach Zahlungseingang aktivieren wir dein Abonnement innerhalb von 1-2 Werktagen.
            </p>
          </div>
        </div>

        <div className="bank-transfer-actions">
          <button 
            onClick={() => navigate('/dashboard')} 
            className="btn-primary"
            data-testid="go-to-dashboard-button"
          >
            Zum Dashboard
          </button>
          <button 
            onClick={() => navigate('/pricing')} 
            className="btn-secondary"
            data-testid="back-to-pricing-button"
          >
            Zurück zur Preisübersicht
          </button>
        </div>

        <div className="contact-info">
          <p>Bei Fragen kontaktiere uns unter:</p>
          <p><strong>📧 support@zenta.me</strong></p>
        </div>
      </div>
    </div>
  );
}

export default BankTransferPage;